import { Icon } from '@iconify/react';
import React from 'react'
import Slider from "react-slick";
import Section from '../Section';
import CardStype2 from '../Card/CardStype2'

export default function RoadmapSlider() {
  const data = [
    {
      phase:'Phase 1', 
      title:'Whitelisting',
      subtitle:'<del>Introductory AMA (x.com)</del><br><del>Website Launch & Social Media Presence</del><br><del>Corporate KYC Compliance </del><br><del>Whitelisting Initiatives</del><br><del>Smart Contract Creation</del><br><del>Smart Contract Audit Cyberscope</del>',
    },{
      phase:'Phase 2', 
      title:'AMA on x.com',
      subtitle:'<del>AMA (x.com)</del><br><del>PinkSale Launchpad</del><br><del>Pancakeswap Trading Pair Integration</del><br>CoinMarketCap<br>CoinGecko',
    },{
      phase:'Phase 3', 
      title:'Catchcoin Stablecoin (CS) Launch',
      subtitle:'AMA (x.com)<br>Phase 1 Marketing Campaign<br>CEX listing<br>Catchcoin Stablecoin (CS) Launch',
    },{
      phase:'Phase 4',
      title:'Platform Unveiling',
      subtitle:'Introductory AMA (x.com)<br>Platform Unveiling<br>iOS/Android App Store Launch'
    },{
      phase:'Phase 5', 
      title:'Platform Launch',
      subtitle:'Introductory AMA (x.com)<br>Phase 1 User Acquisition<br>Phase 2 Merchant Acquisition',
    },{
      phase:'Phase 6', 
      title:'Cash Drops',
      subtitle:'Introductory AMA (x.com)<br>Cash Drops<br>Phase 2 Marketing Strategies',
    },{
      phase:'Phase 7', 
      title:'catchcoin PAY launch',
      subtitle:'Introductory AMA (x.com)<br>Partner Program Activation<br>Catchcoin Pay Launch',
    },
  ]
  const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
    <div
      {...props}
      className={
        "slick-prev slick-arrow" +
        (currentSlide === 0 ? " slick-disabled" : "")
      }
      aria-hidden="true"
      aria-disabled={currentSlide === 0 ? true : false}
    >
      <Icon icon="material-symbols:chevron-left-rounded" />
    </div>
  );
  const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    <div
      {...props}
      className={
        "slick-next slick-arrow" +
        (currentSlide === slideCount - 1 ? " slick-disabled" : "")
      }
      aria-hidden="true"
      aria-disabled={currentSlide === slideCount - 1 ? true : false}
    >
      <Icon icon="material-symbols:chevron-right-rounded" />
    </div>
  );
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: <SlickArrowLeft />,
    nextArrow: <SlickArrowRight />,
    responsive: [
      {
        breakpoint: 1285,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  };
  return (
    <Slider {...settings} className='cs-gap-24 cs-awwow_style_1 cs-type1'>
      {data.map((item, index)=> (
        <Section key={index}>
          <CardStype2 
            cardNumber={index+1}
            phase={item.phase}
            title={item.title}
            
            subtitle={item.subtitle}
          />
        </Section>
      ))}
    </Slider>
  )
}
